var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframecomp',{attrs:{"iframe-url":"https://dmtlp.zone-it.studio/grafana/public-dashboards/6554f3c8614741ada85daeb77533108b"}})
}
var staticRenderFns = []

export { render, staticRenderFns }